import apiFetch from '../apiFetch'

export default function (token, organizedUnitConfiguration) {
  return apiFetch({ endPoint: `OrganizedUnitConfiguration/${organizedUnitConfiguration.organizedUnitConfigurationId}`, method: 'DELETE', body: null, token: token })
}
